export default {
  labels: {
    google_place: 'Google-locatie',
    live: 'Live',
    setting_up: 'Instellen',
  },
  buttons: {
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    continue_setup: 'Doorgaan met instellen',
  },
  delete_confirmation: 'Weet u het zeker?',
};
